module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/PlayBlackDisabled.0c8a2c24.svg";